import React from "react";
import { Reveal } from "./shared";
import { GALLERY } from "../../lib/data";
import img6282 from "../../assets/IMG_6282.jpg";
import kids from "../../assets/kids-training.jpg";
import img6557 from "../../assets/IMG_6557_2.jpg";
import republic from "../../assets/republic-day-group.jpg";
import img6558 from "../../assets/IMG_6558_2.jpg";
import img6955 from "../../assets/IMG_6955.jpg";

const SRC = {
  "IMG_6282.jpg": img6282,
  "kids-training.jpg": kids,
  "IMG_6557_2.jpg": img6557,
  "republic-day-group.jpg": republic,
  "IMG_6558_2.jpg": img6558,
  "IMG_6955.jpg": img6955,
};

export const Gallery = () => (
  <section className="section" id="gallery" data-testid="gallery-section">
    <div className="container">
      <Reveal><p className="eyebrow">Gallery</p></Reveal>
      <Reveal delay={0.05}>
        <h2 className="section-title" style={{ marginTop: 16 }}>Inside the <span className="accent">dojo</span></h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="section-sub">A look at training days, gradings, and the community behind the belts.</p>
      </Reveal>

      <div style={{ columnCount: 3, columnGap: 20, marginTop: 48 }} className="masonry">
        {GALLERY.map((g, i) => (
          <Reveal key={g.src} delay={(i % 3) * 0.06} y={30}>
            <div className="gitem" data-testid={`gallery-item-${i}`}>
              <img src={SRC[g.src]} alt={g.label} loading="lazy" />
              <span className="glabel">{g.label}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
